import type { ParseKeys } from 'i18next'

export type CareerColorKey =
  | 'red-1'
  | 'red-2'
  | 'red-3'
  | 'yellow-1'
  | 'yellow-2'
  | 'yellow-3'
  | 'orange-1'
  | 'orange-2'
  | 'pink'
  | 'green-1'
  | 'green-2'
  | 'green-3'
  | 'green-4'
  | 'blue-1'
  | 'blue-2'
  | 'blue-3'
  | 'blue-4'
  | 'blue-5'
  | 'grey-1'
  | 'grey-2'
  | 'grey-3'
  | 'gold-1'
  | 'gold-2'

export type CareerColor = {
  color: string
  imageBackgroundColor: string
  textButtonColor: string
  label: ParseKeys<'network.career_website'> // @TranslationNeeded on all keys.
}

export const CareerThemeColors: Record<CareerColorKey, CareerColor> = {
  'red-1': {
    color: '#8A4651',
    imageBackgroundColor: '#62323A',
    textButtonColor: '#FFFFFF',
    label: 'Rouge 1' as ParseKeys<'network.career_website'>,
  },
  'red-2': {
    color: '#A52D33',
    imageBackgroundColor: '#742024',
    textButtonColor: '#FFFFFF',
    label: 'Rouge 2' as ParseKeys<'network.career_website'>,
  },
  'red-3': {
    color: '#C0312E',
    imageBackgroundColor: '#902522',
    textButtonColor: '#FFFFFF',
    label: 'Rouge 3' as ParseKeys<'network.career_website'>,
  },
  'yellow-1': {
    color: '#EA9736',
    imageBackgroundColor: '#583E20',
    textButtonColor: '#131415',
    label: 'Jaune 1' as ParseKeys<'network.career_website'>,
  },
  'yellow-2': {
    color: '#E1A93A',
    imageBackgroundColor: '#4F3D1B',
    textButtonColor: '#131415',
    label: 'Jaune 2' as ParseKeys<'network.career_website'>,
  },
  'yellow-3': {
    color: '#EAC241',
    imageBackgroundColor: '#58441D',
    textButtonColor: '#131415',
    label: 'Jaune 3' as ParseKeys<'network.career_website'>,
  },
  'orange-1': {
    color: '#AC4F2C',
    imageBackgroundColor: '#6A301B',
    textButtonColor: '#FFFFFF',
    label: 'Orange 1' as ParseKeys<'network.career_website'>,
  },
  'orange-2': {
    color: '#C96C37',
    imageBackgroundColor: '#894925',
    textButtonColor: '#FFFFFF',
    label: 'Orange 2' as ParseKeys<'network.career_website'>,
  },
  pink: {
    color: '#EE9483',
    imageBackgroundColor: '#BD523D',
    textButtonColor: '#131415',
    label: 'Rose' as ParseKeys<'network.career_website'>,
  },
  'green-1': {
    color: '#336A60',
    imageBackgroundColor: '#19342F',
    textButtonColor: '#FFFFFF',
    label: 'Vert 1' as ParseKeys<'network.career_website'>,
  },
  'green-2': {
    color: '#3E8C70',
    imageBackgroundColor: '#245141',
    textButtonColor: '#FFFFFF',
    label: 'Vert 2' as ParseKeys<'network.career_website'>,
  },
  'green-3': {
    color: '#8CC270',
    imageBackgroundColor: '#41682C',
    textButtonColor: '#131415',
    label: 'Vert 3' as ParseKeys<'network.career_website'>,
  },
  'green-4': {
    color: '#367B89',
    imageBackgroundColor: '#142E33',
    textButtonColor: '#FFFFFF',
    label: 'Vert 4' as ParseKeys<'network.career_website'>,
  },
  'blue-1': {
    color: '#0196C7',
    imageBackgroundColor: '#003D51',
    textButtonColor: '#FFFFFF',
    label: 'Bleu 1' as ParseKeys<'network.career_website'>,
  },
  'blue-2': {
    color: '#62C1B1',
    imageBackgroundColor: '#205048',
    textButtonColor: '#131415',
    label: 'Bleu 2' as ParseKeys<'network.career_website'>,
  },
  'blue-3': {
    color: '#17296F',
    imageBackgroundColor: '#0B1333',
    textButtonColor: '#FFFFFF',
    label: 'Bleu 3' as ParseKeys<'network.career_website'>,
  },
  'blue-4': {
    color: '#2C67A0',
    imageBackgroundColor: '#142E48',
    textButtonColor: '#FFFFFF',
    label: 'Bleu 4' as ParseKeys<'network.career_website'>,
  },
  'blue-5': {
    color: '#3A83DA',
    imageBackgroundColor: '#071D6A',
    textButtonColor: '#FFFFFF',
    label: 'Bleu 5' as ParseKeys<'network.career_website'>,
  },
  'grey-1': {
    color: '#3F3F3F',
    imageBackgroundColor: '#242424',
    textButtonColor: '#FFFFFF',
    label: 'Gris 1' as ParseKeys<'network.career_website'>,
  },
  'grey-2': {
    color: '#345776',
    imageBackgroundColor: '#1B2C3C',
    textButtonColor: '#FFFFFF',
    label: 'Gris 2' as ParseKeys<'network.career_website'>,
  },
  'grey-3': {
    color: '#4D6166',
    imageBackgroundColor: '#1D2426',
    textButtonColor: '#FFFFFF',
    label: 'Gris 3' as ParseKeys<'network.career_website'>,
  },
  'gold-1': {
    color: '#dcb680',
    imageBackgroundColor: '#00314C',
    textButtonColor: '#00314C',
    label: 'Or 1' as ParseKeys<'network.career_website'>,
  },
  'gold-2': {
    color: '#D8A54F',
    imageBackgroundColor: '#053f6d',
    textButtonColor: '#053f6d',
    label: 'Or 2' as ParseKeys<'network.career_website'>,
  },
}
